import { CSSProperties, ReactNode } from 'react';
import { StatusTone } from './StatusDot';

export type PillTone = StatusTone | 'none';

const TONES: Record<PillTone, { fg: string; bg: string; border: string }> = {
  success: {
    fg: 'var(--bui-fg-success)',
    bg: 'var(--bui-bg-success)',
    border: 'var(--bui-border-success)',
  },
  warning: {
    fg: 'var(--bui-fg-warning)',
    bg: 'var(--bui-bg-warning)',
    border: 'var(--bui-border-warning)',
  },
  danger: {
    fg: 'var(--bui-fg-danger)',
    bg: 'var(--bui-bg-danger)',
    border: 'var(--bui-border-danger)',
  },
  neutral: {
    fg: 'var(--bui-fg-secondary)',
    bg: 'var(--bui-bg-neutral-2)',
    border: 'var(--bui-border-1)',
  },
  none: {
    fg: 'var(--bui-fg-secondary)',
    bg: 'var(--bui-bg-neutral-2)',
    border: 'var(--bui-border-1)',
  },
};

const base: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  fontSize: 12.5,
  fontWeight: 600,
  borderRadius: 999,
  border: '1px solid',
  whiteSpace: 'nowrap',
};

export const HealthPill = ({
  tone,
  icon,
  children,
}: {
  tone: PillTone;
  icon?: ReactNode;
  children: ReactNode;
}) => {
  const colors = TONES[tone];
  return (
    <span
      style={{
        ...base,
        padding: icon ? '3px 11px 3px 8px' : '3px 11px',
        color: colors.fg,
        background: colors.bg,
        borderColor: colors.border,
      }}
    >
      {icon}
      {children}
    </span>
  );
};
